import { render, staticRenderFns } from "./ClaimsTable.vue?vue&type=template&id=ae608b1e&"
import script from "./ClaimsTable.vue?vue&type=script&lang=js&"
export * from "./ClaimsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports